import api from './Api';

class ZipCodeService {
  constructor() {
    this.api = api;
  }

  getZipCode(zipCode) {
    return this.api.get(`/zip-code/${zipCode}`);
  }
}

const zipCodeService = new ZipCodeService();
export default zipCodeService;
